/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};

    function LeverJobFeed(elem) {
        Behaviors.init(LeverJobFeed, this, arguments);
        var $thisElem = this.$elem;

        function selectedFilters() {
            var location = $thisElem.find('[name="locationSortName"]').val() ? $thisElem.find('[name="locationSortName"]').val() : '';
            var team = $thisElem.find('[name="teamsSortName"]').val() ? $thisElem.find('[name="teamsSortName"]').val() : '';
            var department = $thisElem.find('[name="departmentSortName"]').val() ? $thisElem.find('[name="departmentSortName"]').val() : '';
            var commitment = $thisElem.find('[name="workTypeSortName"]').val() ? $thisElem.find('[name="workTypeSortName"]').val() : '';

            var mainSelector = location ? '.' + location : '';
                mainSelector = team ? mainSelector + '.' + team : mainSelector;
                mainSelector = commitment ? mainSelector + '.' + commitment : mainSelector;
                // mainSelector = department ? mainSelector + '.' + department : mainSelector;
            return mainSelector ? mainSelector : '.LeverJobFeed-content_tabs_items_item_posts_post';
        }

        //Load more button logic
        // this.$elem.find(LeverJobFeed.ELEMENTS.loadMoreButton).on("click", function (e) {
        //     e.preventDefault();
        //     var $this = jQuery(this),
        //         tab = jQuery(this).parents('.LeverJobFeed-content_tabs_items_item');

        //     var mainSelector = selectedFilters();

        //     $(mainSelector + ':hidden').slice(0, 8).slideDown();
        //     if (tab.find(mainSelector + ':hidden').length == 0) {
        //         $this.text("No more posts to load").addClass("LeverJobFeed-content_tabs_items_item_loadMore__button--noContent");
        //     }
        // });

        //Filter items logic
        $('.LeverJobFeed-content_filters select').on('change', function () {

            var mainSelector = selectedFilters();

            mainSelector = mainSelector.replace('.all', '').replace('.all', '').replace('.all', '');

            $('.LeverJobFeed-content_tabs_items_item_posts_post').hide(); // hide all items
            $('#LeverJobFeed_filters-clear').show(); // Ja - Show clear filter when select items

            if (mainSelector) {
                // $(mainSelector).slice(0, 8).show(); // show first 8 items when filters selected
                $(mainSelector).show(); // show first 8 items when filters selected
            } else {
                // $('.LeverJobFeed-content_tabs_items_itsem_posts_post').slice(0, 8).show(); // show 8 first items when filters not selected
                $('.LeverJobFeed-content_tabs_items_item_posts_post').show(); // show 8 first items when filters not selected
            }

            // Show/Hide Load more button
            if ($(mainSelector).length > 8) {
                $('.LeverJobFeed-content_tabs_items_item_posts_loadMore_button').show();
                $('.LeverJobFeed-content_tabs_items_item_posts_loadMore_button a').text("Load more").removeClass("LeverJobFeed-content_tabs_items_item_loadMore__button--noContent");
            } else {
                $('.LeverJobFeed-content_tabs_items_item_posts_loadMore_button').hide();
            }

            //Ja - Show/Hide No result message
            if (($(mainSelector).length) == 0) {
                $('.LeverJobFeed-content_tabs_items_item_posts--no-results').show();
            } else {
                $('.LeverJobFeed-content_tabs_items_item_posts--no-results').hide();
            }

        });
        
        //Ja - Clear filter button
        $('#LeverJobFeed_filters-clear').on('click', function(e) {
            e.preventDefault();
            var $this = jQuery(this);
            $this.hide();
            $('.LeverJobFeed-content_filters select').prop('selectedIndex',0);
            $('.LeverJobFeed-content_tabs_items_item_posts_post').hide();
            // $('.LeverJobFeed-content_tabs_items_item_posts_post:hidden').slice(0, 8).show();
            $('.LeverJobFeed-content_tabs_items_item_posts_post:hidden').show();
            $('.LeverJobFeed-content_tabs_items_item_posts--no-results').hide();
            $('.LeverJobFeed-content_tabs_items_item_posts_loadMore_button').show();
            $('.LeverJobFeed-content_tabs_items_item_posts_loadMore_button a').text("Load more").removeClass("LeverJobFeed-content_tabs_items_item_loadMore__button--noContent");
        });

        //Ja - Mobile Filter toggle
        $('.LeverJobFeed-content_filters_mobile_toggle').on('click', function() {
            var $this = jQuery(this);
            $this.parent('.LeverJobFeed-content_filter_items').toggleClass('LeverJobFeed-content_filter_items--filters-active');
            $('#LeverJobFeed_filters').slideToggle('slow');
        })

    }
    Behaviors.inherit(LeverJobFeed, Behaviors.Behavior);
    LeverJobFeed.QUERY = "[data-lever-job-feed]";
    LeverJobFeed.ELEMENTS = {
        loadMoreButton: ".LeverJobFeed-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(LeverJobFeed);
    module.LeverJobFeed = LeverJobFeed;
    return module;
}(window.jQuery, window.Behaviors));
